import { useState, useEffect, useRef } from 'react';
import { Button, Col, Row, Tab, Tabs } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import edit from "../../../assets/images/edit.png";
import EditIcon from "../../../assets/images/view.png";
import view from "../../../assets/images/chat.png";
import MailGreen from '../../../assets/images/mail_green.png';
import MailRed from '../../../assets/images/mail_red.png';
import { withRFSToken } from '../../../Services/axios.js';
import { toast } from 'react-toastify';
const AirlineSetting = () => {
    const gridRefs = {
        Active: useRef(null),
    };
    const [filterApplied, setFilterApplied] = useState(false);
    let checkUlds = [];
    let filterForCheck = false;
    const SBack = localStorage.getItem('SettingsBack');
    const [gridSelect, setGridSelect] = useState([]);
    const [activeTab, setActiveTab] = useState('Active');
    const [gridData, setGridData] = useState({
        Active: []
    });
    const [isLoading, setIsLoading] = useState(true);
    const isMounted = useRef(false);
    useEffect(() => {
        if (isMounted.current) return;
        setIsLoading(false);
        setGridData({ Active: {} });
        isMounted.current = true;
    }, []);
    useEffect(() => {
        if (gridRefs[activeTab]?.current) {
            var token = "Bearer " + localStorage.SPL;
            let tabType = '';
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'airline_code', type: 'string' },
                    { name: 'IATA', map: 'airline_master>IATA', type: 'string' },
                    { name: 'email', type: 'string' },
                    { name: 'email_notification_status', type: 'string' },
                    { name: 'id', type: 'string' },
                    { name: 'org_name', type: 'string' },
                    { name: 'phone', type: 'string' },
                    { name: 'pickup_emails', type: 'string' },
                ],
                id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}rfs-setting/org-list?org_type=A`,
                beforeSend: function (jqXHR) {
                    jqXHR.setRequestHeader('Authorization', token);
                },
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                // {
                //     text: 'Actions',
                //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                //         let editable = '<div class="grid_actions">';
                //         editable += '<div><img src="' + edit + '" class="row_edit" /></div></div>';
                //         return editable;
                //     },
                //     width: '25%', filterable: false,
                // },
                { text: 'Airline Name', filtertype: 'input', datafield: 'org_name', width: '33%', cellclassname: '', },
                { text: 'Airline Code', filtertype: 'input', datafield: 'IATA', width: '33%' },
                {
                    text: 'Email Notification',
                    datafield: 'email_notification_status',
                    width: '33%',
                    cellsrenderer: (row, column, val, rowData) => {
                        const isChecked = val === 1 ? 'checked' : '';
                        const switchColor = val === 1 ? 'bg-success' : 'bg-danger';
                        const id = rowData.id;
                        return `
                            <div style="margin-top:13px;">
                                <div class="form-check form-switch">
                                    <input 
                                    class="form-check-input switchActiveInactive door_switchActiveInactive"  type="checkbox" role="switch" 
                                    ${isChecked} />
                                </div>
                            </div>`;
                    }
                },
            ];

            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rowdetailstemplate: {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (5 * 45),
                    rowdetailshidden: true,
                },
                rendergridrows: function (params) {
                    return params.data;
                },
                rendered: function () {
                    const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };
            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function (event) {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                // loadDetails('E', rowData.service_recovery_id);
                // localStorage.removeItem('RecoveryEdit');
                // localStorage.setItem('RecoveryEdit', JSON.stringify(rowData));
                // const fnPageUrl = '/OverviewDetails';
                // window.location.href = fnPageUrl;
            });
            // window.$(gridRefs[activeTab].current).on('click', '.row_update', function (event) {
            //     const rowDiv = window.$(this).closest('[role="row"]');
            //     const rowIndex = window.$(rowDiv).attr('row-id');
            //     const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
            //     // loadDetails('U', rowData.service_recovery_id);
            //     localStorage.setItem('RecoveryUpdate', JSON.stringify(rowData.service_recovery_id));
            //     localStorage.setItem('BackRecoveryUpdate', '/ServiceRecovery');
            //     window.location.href = '/UpdateRecoveryCase';
            // });
            // window.$(gridRefs[activeTab].current).on('click', '.row_msg', function (event) {
            //     const rowDiv = window.$(this).closest('[role="row"]');
            //     const rowIndex = window.$(rowDiv).attr('row-id');
            //     const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

            //     if (boundIndex !== undefined) {
            //         const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
            //         const pageIndex = pagingInfo.pagenum;
            //         const pageSize = pagingInfo.pagesize;
            //         const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
            //         // console.log('Global Index:', globalIndex); 
            //         const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
            //         if (rowData) {
            //             // console.log('Row Data:', rowData);
            //             // window.location.href = '/MessageRecovery';
            //             const transData = { ...rowData, selb: 'msg' }
            //             localStorage.removeItem('RecoveryEdit');
            //             localStorage.setItem('RecoveryEdit', JSON.stringify(transData));
            //             const fnPageUrl = '/OverviewDetails';
            //             window.location.href = fnPageUrl;
            //             // loadDetails('M', rowData.service_recovery_id);
            //         } else {
            //             console.error('No data found for the given row index.');
            //         }
            //     } else {
            //         console.error('Bound index could not be retrieved. Check the row index and data binding.');
            //     }
            // });
            // window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
            //     window.$(row).on('mouseover', () => {
            //         window.$(row).addClass('row-hover');
            //     });
            //     window.$(row).on('mouseout', () => {
            //         window.$(row).removeClass('row-hover');
            //     });
            // });
            // window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
            //     if (event.args.row) {
            //         const selectedRow = event.args.row;
            //         const uldNumber = selectedRow.service_recovery_id;
            //         const selectedRowId = selectedRow.uid;
            //         if (!checkUlds.includes(uldNumber)) {
            //             checkUlds.push(uldNumber);
            //         }
            //         // console.log(checkUlds);
            //         // if (!gridSelect.some(row => row.service_recovery_id === uldNumber)) {
            //         //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
            //         // }
            //         setGridSelect(prevGridSelect => {
            //             if (!prevGridSelect.some(row => row.service_recovery_id === uldNumber)) {
            //                 return [...prevGridSelect, selectedRow];
            //             }
            //             return prevGridSelect;
            //         });
            //     } else {
            //         if (event.args.rowindex.length > 0) {
            //             const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
            //             setGridSelect(allIds);
            //         } else {
            //             setGridSelect([]);
            //         }
            //     }
            // });
            // window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
            //     if (event.args.row) {
            //         const unselectedRowId = event.args.row.service_recovery_id;
            //         setGridSelect(prevSelection => prevSelection.filter(row => row.service_recovery_id !== unselectedRowId));
            //         // if(filterForCheck!=true){
            //         if (!checkUlds.includes(unselectedRowId)) {
            //             checkUlds.push(unselectedRowId);
            //         } else {
            //             checkUlds = checkUlds.filter(item => item !== unselectedRowId);
            //         }
            //         // }
            //         // console.log(checkUlds);

            //     }
            // });
            // window.$(gridRefs[activeTab].current).off('cellclick');
            // window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
            //     const args = event.args.row.bounddata;
            //     if (event.args.columnindex > 2) {
            //         if (gridSelect) {
            //             gridSelect.forEach(item => {
            //                 const selectedRowBoundIndex = item.boundindex;
            //                 window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
            //             });
            //         }
            //         // loadDetails('D', args.service_recovery_id);
            //     }
            // });
            window.$(gridRefs[activeTab].current).on('click', '.switchActiveInactive', function (event) {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);
                const changeStatus = rowData.email_notification_status === 0 ? 1 : 0;
                // const updatedFormData = {
                //   door_id: rowData.id,
                //   action: changeStatus,

                // };
                handleUpdateDoor(rowData.id, changeStatus);
            });
        }
    }, [gridData]);
    const handleUpdateDoor = async (id, action) => {
        const alldata = {
            id: id,
            status: action
        };
        try {
            const res = await withRFSToken.post('rfs-setting/toggle-email-notification', alldata)
                .then(function (res) {
                    if (res.data.response_code == 200) {
                        toast.success(res.data.response_msg);
                    } else {
                        toast.error(res.data.response_msg);
                    }
                    const grid = window.$(gridRefs[activeTab].current);
                    grid.jqxGrid('updatebounddata');
                    grid.jqxGrid('refresh');
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    return (
        // <div className="">
        //     <Header logo_url={SBack ? SBack : '/PlanningDashboard'} sBackUrl={SBack ? SBack : '/PlanningDashboard'} />
        //     <div className="main-panel">
        //         <div className="row">
        //             <LeftSettings />
                    <div className='col-9 col-xxl-9 stting_right'>
                        <div className='settingbg_right'>
                            <h4>Airline Setting</h4>
                            <p>Manage and configure doors to add them to your system</p>
                            <div className='row'>
                                <div className='col-6'>
                                    {!isLoading && <div ref={gridRefs.Active} className='staion_grid' ></div>}
                                </div>
                            </div>
                        </div>
                    </div>
        //         </div>
        //     </div>
        // </div>
    )
}

export default AirlineSetting